import React from 'react'
import internet from '../assets/rightLoginImg.jpg'
import ResetPassword from './ResetPassword'
import avatar from '../assets/Logo.png'
const PasswordReset = () => {

    
    return (
        <div>
            {/* <img className="wave" src={wave} alt="" /> */}
            <div className="auth-container">
              <div className="login-content row">
                  <div className='col-12 col-xs-6'>
                    <div className='smslogo'>
                      <img src={avatar} alt="" />
                    </div>
                    <ResetPassword/>
                  </div>
              </div>
                
              <div className="img">
                  <img src={internet} alt="" className='loginimg'/>
              </div>
            </div>
        </div>
    )
}

export default PasswordReset